import React from 'react';
import { Heading, Body, Link } from '@hover/blueprint';
import { TRUST_CENTER_FAQ } from '../../constants';
import { SharedFaq } from '../common';

const FAQ: React.FC = () => (
  <>
    <Heading as="h2" size={500} mt="56px">
      FAQ
    </Heading>
    <Body mb={500}>
      Here’s more information about our privacy and security practices. If you
      don’t find what you are looking for, please check our help center or
      contact us at{' '}
      <Link href="mailto:privacy@hover.to" fontWeight={400}>
        privacy@hover.to
      </Link>
      .
    </Body>
    <SharedFaq questions={TRUST_CENTER_FAQ} />
  </>
);

export default FAQ;
